export const projects = [
  {
    _id: "6431e0df5a895e0e9b327c22",
    name: "Halum",
    description: "A Entertainment media app",
    images: [
      "https://i.ibb.co/mc8qVxc/Screenshot-from-2023-08-05-02-10-42.png",
      "https://i.ibb.co/bL3gB1k/Screenshot-from-2023-08-05-02-06-40.png",
      "https://i.ibb.co/ChFLHs3/Screenshot-from-2023-08-05-02-09-34.png",
    ],
    features: [
      "Displayed movie information, including ratings, trailers, cast, crew, official videos, and related videos.",
      "Users can search for movies based on various categories, and the real-time search bar provides suggested movies.",
      "Using TMDB API to search for movies across various genres.",
    ],
    duration: "24 Jun, 23 - 05 Jul, 23",
    technologies: [
      "React JS",
      "Tailwind CSS",
      "TMDB API",
      "React query",
      "Infinity scroll",
      "React Suspense",
      "React Player",
      "Daisy UI",
    ],
    client: "https://github.com/Gm-shuvo/Halum",
    server: "https://github.com/Gm-shuvo/Halum",
    liveLink: "https://halum-bd.vercel.app/",
    img: "https://i.ibb.co/mc8qVxc/Screenshot-from-2023-08-05-02-10-42.png",
  },
  {
    _id: "6431e0df5a895e0e9b327c23",
    name: "Job-Bit",
    description: "A Full Stack Aggregated job portal web app",
    images: [
      "https://i.ibb.co/9nhJ2ny/Screenshot-from-2023-08-15-12-36-43.png",
      "https://i.ibb.co/TLzSTrF/Screenshot-from-2023-08-15-12-38-12.png",
      "https://i.ibb.co/hsdBKtH/Screenshot-from-2023-08-15-12-39-37.png",
    ],
    features: [
      "Unified job portal aggregating listings from multiple sources (LinkedIn, Careerjet, Job-Bit(own)).",
      "Robust search engine with specific filtering options (job title, company, location, types, and levels).",
      "Dedicated dashboard for application tracking, CV uploads, and bookmarking.",
      "AWS Lambda for automatic scraping of latest LinkedIn Jobs and CareerJet jobs.",
    ],
    duration: "18 Apr, 23 - Now",
    technologies: [
      "Next JS",
      "Tailwind CSS",
      "Node JS",
      "MongoDb",
      "JWT auth",
      "Cloudinary",
      "AWS lambda",
    ],
    client: "https://github.com/Gm-shuvo/Aggregated-Job-Portal",
    server: "https://github.com/Gm-shuvo/Aggregated-Job-Portal",
    liveLink: "https://job-bit.vercel.app/",
    img: "https://i.ibb.co/9nhJ2ny/Screenshot-from-2023-08-15-12-36-43.png",
  },
  {
    _id: "6431e0df5a895e0e9b327c24",
    name: "Dokan",
    description: "Full Stack E-commerce using Commerce Js CMS",
    images: [
      "https://i.ibb.co/qYg61gc/Screenshot-from-2023-08-15-12-41-14.png",
      "https://i.ibb.co/pWn4rvd/Screenshot-from-2023-08-15-12-43-04.png",
      "https://i.ibb.co/HGn5mbv/Screenshot-from-2023-08-15-12-46-29.png",
      
    ],
    features: [
      "User authentication with Firebase, intuitive product browsing, and convenient cart management.",
      "Hotdeals, related product suggestions, and categorized searches.",
      "Wishlist creation, promotional sections, and cross-selling opportunities and checkout using stripe.",
    ],
    duration: "25 July, 23 - 05 August, 23",
    technologies: [
      "React JS",
      "Material UI",
      "Firebase",
      "Commerce Js",
      "Stripe",
      "React Router",
      "React Context API",
      "React Lazy Load",
    ],
    client: "https://github.com/Gm-shuvo/Dokan",
    server: "https://github.com/Gm-shuvo/Dokan",
    liveLink: "https://dokan-gm.vercel.app/",
    img: "https://i.ibb.co/qYg61gc/Screenshot-from-2023-08-15-12-41-14.png",
  },
  {
    _id: "6431e0df5a895e0e9b327c25",
    name: "Deliverooo",
    description: "A Landing page of Delivery service agency",
    images: [
      "https://i.ibb.co/XtVyTwZ/Screenshot-from-2023-08-15-12-51-44.png",
      "https://i.ibb.co/LpGhTKy/image.png",
    
    ],
    features: [
      "A landing page of a delivery service agency.",
      "Responsive design with mobile-first approach.",
      "Smooth scroll and scroll to top button.",
      "Implemente latested teach stacks React, Tailwind and Aos library ",
      "Animation effects gives more UX and UI",
    ],
    duration: "25 Feb, 23 - 28 Mar, 23",
    technologies: ["React JS", "Tailwind CSS", "Aos Library"],
    client: "https://github.com/Gm-shuvo/Deliverooo-Landing_page",
    server: "",
    liveLink: "https://deliverooo.vercel.app/",
    img: "https://i.ibb.co/XtVyTwZ/Screenshot-from-2023-08-15-12-51-44.png",
  },

  {
    _id: "6431e0df5a895e0e9b327c26",
    name: "Bookshore",
    description: "A Bookstore for managing old Books in Laravel",
    images: [
      "https://user-images.githubusercontent.com/48257565/252464770-c72b35ae-ca0d-436d-8b87-c71af07c4e8f.png"
    ],
    features: [
      "A Bookstore for managing old Books in Laravel",
      "Books listed by book name, In stock, writer, publisher, isbn and price.",
      "Admin manage post, edit , delete post.",
      "User sort list books by real time search on book title, publisher name, writer name and Download as pdf formate.",
    ],
    duration: "11 jul, 23 - 18 jul, 23",
    technologies: ["Laravel", "Tailwind CSS", "Livewire", "Alpine JS"],
    client: "https://github.com/Gm-shuvo/BookStore_Laravel",
    server: "",
    liveLink: "",
    img: "https://user-images.githubusercontent.com/48257565/252464770-c72b35ae-ca0d-436d-8b87-c71af07c4e8f.png",
  },
];
